(() => {
  const accordions = document.querySelectorAll('[data-mio-product-accordion]');

  accordions.forEach((accordion) => {
    const items = accordion.querySelectorAll('[data-mio-product-accordion-item]');
    accordion.classList.add('is-enhanced');
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    items.forEach((item, index) => {
      const button = item.querySelector('[data-mio-product-accordion-button]');
      const panel = item.querySelector('[data-mio-product-accordion-panel]');
      if (!button || !panel) return;

      const isOpen = false;
      button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      item.classList.toggle('is-open', isOpen);
      panel.hidden = !isOpen;
      panel.style.maxHeight = isOpen ? `${panel.scrollHeight}px` : '0px';

      const openPanel = () => {
        item.classList.add('is-open');
        button.setAttribute('aria-expanded', 'true');
        panel.hidden = false;

        if (prefersReducedMotion) {
          panel.style.maxHeight = 'none';
          return;
        }

        requestAnimationFrame(() => {
          panel.style.maxHeight = `${panel.scrollHeight}px`;
        });
      };

      const closePanel = () => {
        button.setAttribute('aria-expanded', 'false');

        if (prefersReducedMotion) {
          item.classList.remove('is-open');
          panel.hidden = true;
          panel.style.maxHeight = '0px';
          return;
        }

        panel.style.maxHeight = `${panel.scrollHeight}px`;

        requestAnimationFrame(() => {
          item.classList.remove('is-open');
          panel.style.maxHeight = '0px';
        });
      };

      panel.addEventListener('transitionend', (event) => {
        if (event.propertyName !== 'max-height') return;

        const panelIsOpen = button.getAttribute('aria-expanded') === 'true';
        if (panelIsOpen) {
          panel.style.maxHeight = `${panel.scrollHeight}px`;
        } else {
          panel.hidden = true;
        }
      });

      button.addEventListener('click', () => {
        const shouldOpen = button.getAttribute('aria-expanded') !== 'true';
        if (shouldOpen) {
          openPanel();
        } else {
          closePanel();
        }
      });

      button.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;

        event.preventDefault();
        button.click();
      });
    });
  });

  document.querySelectorAll('[data-mio-product-expandable]').forEach((wrapper) => {
    const content = wrapper.querySelector('[data-mio-product-expandable-content]');
    const button = wrapper.querySelector('[data-mio-product-expandable-button]');
    if (!content || !button) return;

    if (content.scrollHeight <= content.clientHeight + 8) return;

    button.classList.add('is-visible');
    button.addEventListener('click', () => {
      const isExpanded = content.classList.toggle('is-expanded');
      button.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
      button.textContent = isExpanded ? 'Show less' : 'Read full notes';
    });
  });
})();
